import { render, staticRenderFns } from "./SQuesSeven.vue?vue&type=template&id=e801caa8&"
import script from "./SQuesSeven.vue?vue&type=script&lang=js&"
export * from "./SQuesSeven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports